import React from "react";
import { Route, Routes, useParams, Navigate } from "react-router-dom";
import i18n from "i18next";
import { Layout } from "./Layout";
import { Home } from "./Home";
import { Faq } from "./Faq";
import { Search } from "./Search";
import resources from "../lang/resources";
import { DecodingPonzi } from "./decoding/DecodingPonzi";

export const LanguageWrapper = () => {
  let { lang } = useParams();

  if (!Object.keys(resources).includes(lang)) {
    return <Navigate to={`/${i18n.language}/home`} replace />;
  }

  i18n.changeLanguage(lang);
  return (
    <Layout>
      <Routes>
        <Route path="home" element={<Home />} />
        <Route path="faq" element={<Faq />} />
        <Route path="search" element={<Search />} />
        <Route path="search/:id" element={<Search />} />
        <Route path="decoding" element={<DecodingPonzi />} />
        <Route path="smartplus" element={<DecodingPonzi />} />
      </Routes>
    </Layout>
  );
};
